import { render, staticRenderFns } from "./DemandItem.vue?vue&type=template&id=0adeabf3&scoped=true&"
import script from "./DemandItem.vue?vue&type=script&lang=js&"
export * from "./DemandItem.vue?vue&type=script&lang=js&"
import style0 from "./DemandItem.vue?vue&type=style&index=0&id=0adeabf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adeabf3",
  null
  
)

export default component.exports